module.exports = __webpack_public_path__ + "static/img/Keep_Up.9ad5526c.png";